<template>
  <div class="filial-select-popup">
    <v-dialog
      :value="show"
      v-if="show"
      @input="closePopup"
      width="700"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Выберите филиал
        </v-card-title>

        <v-card-text class="pt-3">
          <filial-select-list v-model="selectedFilialId"/>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="success"
            :disabled="!selectedFilialId"
            :loading="selecting"
            @click="submit"
          >
            Выбрать
          </v-btn>
          <v-btn depressed @click="closePopup">
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import FilialSelectList from '@/components/header/FilialSelectList.vue'

  export default {
    name: 'FilialSelectPopup',
    components: { FilialSelectList },
    model: {
      prop: 'show',
      event: 'change',
    },
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      onSubmit: {
        type: Function,
        default: () => false,
      },
    },
    data () {
      return {
        selectedFilialId: null,
        selecting: false,
      }
    },
    methods: {
      closePopup () {
        this.selectedFilialId = null
        this.$emit('change', false)
      },
      async submit () {
        this.selecting = true
        await this.onSubmit(this.selectedFilialId)
        this.selecting = false
        this.$emit('select', this.selectedFilialId)
        this.closePopup()
      },
    },
  }
</script>

<style scoped lang="less"></style>
